<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/169WLXR/tc-custom/9781398418004.jpg?1705766048182" alt="This image is the cover for the book Education In Sounds And Rhythm: Peter And The Wolf"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Education In Sounds And Rhythm: Peter And The Wolf
      </h1>
      <p class="bookDescription body article font2">
        <p>Prokofiev Sergei was a Russian musician born in Sosnovka in 1891. He died in Moscow in 1953. He wrote many symphony compositions, characterised by a simple style and by a vigorous rhythmic energy. Among his compositions, we recall the fairy tale ‘‘Peter and the wolf’’. It is a beautiful fairy tale told through musical instruments. The presentations of work are covered in a strict dialogue between a grandfather and his young nephew. Our imagination is captured by the main characters: Peter, the cat, the bird, the duck, the wolf, the hunters, the grandfather and from the musical instruments: the strings, the clarinet, the flute, the oboe, the horn, the timpani and the bassoon that personify and alternate the speech of these characters.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Giuseppa Russo
      </h2>
      
      <p class="authorDescription body article">Russo Giuseppa was born in 1940. She is married and the mother of three children. She has a degree in literature. She loves nature and the spirit of rhythm and music in all creation. She has taught music education to children from 6 to 13 years. She has written the book Musica prima forma di vita that was published in 1991. She is writing an innovative piece of work consisting of seven books, titled Education to Sounds and Rhythm for Primary Education. In these books, her focus is given to the comparison between nature sounds, images and the artistic expression of composers who took inspiration from nature’s orchestra and used this music as a means of imitation. The following works have been chosen to show how composers describe nature’s sound and rhythm: “Peter and the Wolf” by Sergei Prokofiev “The Four Seasons” by Antonio Vivaldi “Sixth Symphony” by Beethoven “The Carnival of the Animals” by Saint Saens</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a545342c